export const RESET = 'CATEGORY_UPDATE_RESET'
export const SET_ERROR = 'CATEGORY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CATEGORY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CATEGORY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CATEGORY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CATEGORY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CATEGORY_UPDATE_UPDATE_RETRIEVED'
export const UPDATE_TRANSLATION = 'CATEGORY_UPDATE_UPDATE_TRANSLATION'
export const SET_TRANSLATION = 'CATEGORY_UPDATE_SET_TRANSLATION'
export const SET_LANGUAGES = 'CATEGORY_UPDATE_SET_LANGUAGES'
export const TOGGLE_TRANSLATION_LOADING = 'CATEGORY_TOGGLE_TRANSLATION_LOADING'
export const TOGGLE_LANGUAGES_LOADING = 'CATEGORY_TOGGLE_LANGUAGES_LOADING'
